import { ModuleLayout } from '@/components/reusable_components/next'
import Reports from '../../views/Reports/Reports.vue'
import PaymentReport from '../../views/PaymentReports/PaymentReports.vue'

export default {
    path: 'reports',
    component: ModuleLayout,
    children: [
        {
            path: '',
            name: 'reports',
            component: Reports,
            meta: {
                title: 'Reportes',
            },
        },
        {
            path: 'payment',
            name: 'paymentReport',
            component: PaymentReport,
            meta: {
                title: 'Reporte de Pagos',
            },
        },
    ],
    meta: {
        title: 'Reportes',
    },
}
